import { render, staticRenderFns } from "./TServFilterTabComp.vue?vue&type=template&id=fcc6da2c&"
import script from "./TServFilterTabComp.vue?vue&type=script&lang=js&"
export * from "./TServFilterTabComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports